import { styled } from '@mui/material/styles';
import { Box, Typography } from "@mui/material";

export const DateContainer = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2),
  textAlign: 'center',
  '& h3': {
    color: theme.palette.primary.main,
    marginBottom: theme.spacing(1),
    fontWeight: 'bold',
  },
}));

export const ResultTypography = styled(Typography)(({ theme }) => ({
  color: theme.palette.primary.main,
  fontWeight: 'bold',
  textAlign: 'center',
  marginTop: theme.spacing(2),
  [theme.breakpoints.up('xs')]: {
    padding: theme.spacing(2),
    gap: theme.spacing(1),
  },
  [theme.breakpoints.up('md')]: {
    padding: theme.spacing(4),
    gap: theme.spacing(2),
    marginTop: theme.spacing(4),
  },
  background: 'linear-gradient(45deg, #E3F2FD 30%, #BBDEFB 90%)',
  borderRadius: 10,
  boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

export const CalculatorContainer = styled(Box)(({ theme }) => ({
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
}));

export const CalculatorTitle = styled(Typography)(({ theme }) => ({
  fontWeight: 'bold',
  color: '#1976d2',
  [theme.breakpoints.up('xs')]: {
    marginBottom: theme.spacing(3),
  },
  [theme.breakpoints.up('md')]: {
    marginBottom: theme.spacing(5),
  },
  textAlign: 'center',
}));

export const datePickerStyles = {
  width: '100%',
  '& .MuiInputBase-root': {
    backgroundColor: '#f5f5f5',
    borderRadius: 2,
  }
};

export const textFieldStyles = {
  width: '100%',
  '& .MuiOutlinedInput-root': {
    backgroundColor: '#f5f5f5',
    borderRadius: 2,
  }
};

export const selectStyles = {
  width: '100%',
  '& .MuiOutlinedInput-root': {
    backgroundColor: '#f5f5f5',
    borderRadius: 2,
  }
};
